module.exports = __webpack_public_path__ + "img/logo.5e78fa99.png";